export default __webpack_public_path__ + "static/media/bnr3.af9772e6.jpg";